import React from 'react'
import * as PropTypes from 'prop-types';
import BigBlogPostPreview from "./blogPostPreviews/bigBlogPost";
import MediumBlogPostPreview from "./blogPostPreviews/mediumBlogPostPreview";
import SmallBlogPostPreview from "./blogPostPreviews/smallBlogPostPreview";

const PREVIEW_TYPES = [
  'BIG_PREVIEW',
  'MEDIUM_PREVIEW',
  'SMALL_PREVIEW'
];

function BlogPostPreview(props) {
  const {previewType} = props;
  switch (previewType) {
    case 'BIG_PREVIEW':
      return <BigBlogPostPreview {...props}/>;
    case 'MEDIUM_PREVIEW':
      return <MediumBlogPostPreview {...props} />;
    case 'SMALL_PREVIEW':
      return <SmallBlogPostPreview {...props} />;
    default:
      throw new TypeError(`Expected previewType to be one of ${PREVIEW_TYPES.join(',')}, got ${previewType}`);
  }
}

BlogPostPreview.propTypes = {
  previewType: PropTypes.oneOf(PREVIEW_TYPES).isRequired,
  side: PropTypes.oneOf(['toLeft', 'toRight'])
};

export default BlogPostPreview
